export default "__VITE_ASSET__Bu992f8v__"